import React, { useContext } from "react";

// #region Components
import Input from "shared/components/FormElements/Input";
import Button from "shared/components/FormElements/Button";
import CustomSelect from "shared/components/FormElements/Select";
import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";
import ErrorModal from "shared/components/UIElements/ErrorModal";

// #endregion Components

// #region Utils
import { VALIDATOR_REQUIRE } from "shared/util/validators";
// #endregion Utils

// #region Hooks
import { useForm } from "shared/hooks/form-hook";
import { useHttpClient } from "shared/hooks/http-hook";
import { AuthContext } from "shared/context/auth-context";
import { StoreContext } from "shared/context/store-context";
// #endregion Hooks

import { discountTypes } from "shared/util/types";

import "./AccountingItem.css";

const DiscountNew = (props) => {
  const auth = useContext(AuthContext);
  const store = useContext(StoreContext);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const updateStoreItems = store.UpdateAccountingUtils;
  const ItemTypeTR = "İndirim";
  const APIEndPoint = "discounts";

  const itemSubmitHandler = async (event) => {
    event.preventDefault();

    try {
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/${APIEndPoint}`,
        "POST",
        JSON.stringify({
          name: formState.inputs.name.value,
          type: formState.inputs.type.value,
          amount: formState.inputs.amount.value,
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        }
      );

      updateStoreItems();
    } catch (err) {
      console.log(err);
    }
  };

  const [formState, inputHandler] = useForm(
    {
      name: { value: "", isValid: false },
      type: { value: "", isValid: false },
      amount: { value: "", isValid: false },
    },
    false
  );

  if (isLoading) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />

      <form className="new-item-form" onSubmit={itemSubmitHandler}>
        {isLoading && <LoadingSpinner asOverlay />}
        <h3>{ItemTypeTR} Ekle</h3>

        <Input
          id="name"
          element="input"
          type="text"
          label="İndirim Adı"
          validators={[VALIDATOR_REQUIRE()]}
          errorText="İndirim adı giriniz."
          initialValid={false}
          onInput={inputHandler}
        />

        <CustomSelect
          options={discountTypes}
          id="type"
          onInput={inputHandler}
          label="İndirim Türü"
          initialValid={false}
          validators={[VALIDATOR_REQUIRE()]}
        ></CustomSelect>

        <Input
          id="amount"
          element="input"
          type="text"
          label="İndirim Miktarı"
          validators={[VALIDATOR_REQUIRE()]}
          errorText="İndirim miktarı giriniz"
          initialValid={false}
          onInput={inputHandler}
        />

        <Button type="submit" disabled={!formState.isValid}>
          Yeni {ItemTypeTR} Yarat
        </Button>
      </form>
    </React.Fragment>
  );
};

export default DiscountNew;
